import { VFC } from "react";

import { Tab, Tabs } from "@portex-pro/ui-components";
import AppBar from "components/AppBar";
import useLDFlag from "hooks/useLDFlag";
import { useTranslation } from "react-i18next";
import { Link, useRouteMatch } from "react-router-dom";

import { CARRIER_INTEGRATIONS_PAGE_PATH, PARTNERS_PAGE_PATH } from "../routing";

const PartnersPagesTabsContainer: VFC = () => {
  const routeMatch = useRouteMatch();
  const { t } = useTranslation(["shipper"]);
  const enableLtlAutoPricing = useLDFlag("enableLtlAutoPricing");

  const tabsMap = {
    partnersTab: {
      path: PARTNERS_PAGE_PATH,
      label: t("shipper:partners"),
      hide: false,
    },
    carriersTab: {
      path: CARRIER_INTEGRATIONS_PAGE_PATH,
      label: t("shipper:carrierIntegrations"),
      hide: !enableLtlAutoPricing,
    },
  };

  const tabs = Object.values(tabsMap)
    .filter((tab) => !tab.hide)
    .map(({ hide: _hide, ...tab }) => tab);

  return (
    <AppBar>
      <Tabs value={tabs.length > 1 ? routeMatch.path : undefined}>
        {tabs.map((tab) => (
          <Tab key={tab.path} component={Link} to={tab.path} value={tab.path} label={tab.label} />
        ))}
      </Tabs>
    </AppBar>
  );
};

export default PartnersPagesTabsContainer;
